import { Collapse } from "antd";
import styled from "styled-components";

export const StyledCLCollapse = styled(Collapse)`
    overflow-y: auto;
    width: 100%;
    border: none;
    border-radius: 0;
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .ant-collapse-content-box {
        padding: 8px;
    }

    .ant-collapse-header,
    .ant-collapse-item-active {
        border-radius: 0 10px 10px 0 !important;
    }
`;
